import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { Share } from '@/components/Share/Share';
import { EntityType, Hcphco } from '@/core/graphql/generated/types';
import { Permission } from '@/core/store/auth/auth.types';
import { useHasPermission } from '@/core/store/auth/authSelectors';

import { DcrControl } from '../DcrControl/DcrControl';
import { ProfileActionsMenu } from '../ProfileActionsMenu/ProfileActionsMenu';
import { ProfileReactivateControl } from '../ProfileReactivateControl/ProfileReactivateControl';

import { profilePageHeaderStyles as sx } from './ProfilePageHeader.styles';

type Props = {
	profile: Hcphco | null;
};

export const ProfilePageHeader = ({ profile }: Props) => {
	const { t } = useTranslation();
	const dcrEnabled = useHasPermission(Permission.DcrEnabled);
	const entityType =
		profile?.__typename === 'HCP' ? EntityType.Hcp : EntityType.Hco;
	const isInactive = profile?.statusCda_VId === 'iact';

	return (
		<Box sx={sx.headerRow}>
			<Typography sx={sx.typeLabel} variant='body1'>
				{profile?.__typename === 'HCP' ? t('HCP') : t('HCO')}
			</Typography>

			<Box sx={sx.headerActions}>
				{dcrEnabled && isInactive ? (
					<>
						<ProfileReactivateControl
							profile={profile}
							entityType={entityType}
						/>

						<Share
							title={t('Share this profile')}
							collapseAt='sm'
							description={t(
								'Copy and paste the link above to share this profile.'
							)}
							variant='outlined'
						/>
					</>
				) : (
					<>
						<DcrControl />

						{!dcrEnabled && (
							<Share
								title={t('Share this profile')}
								collapseAt='lg'
								description={t(
									'Copy and paste the link above to share this profile.'
								)}
							/>
						)}

						{profile && (
							<ProfileActionsMenu profile={profile} entityType={entityType} />
						)}
					</>
				)}
			</Box>
		</Box>
	);
};
